import {useState} from "react";
import {BASE_URL} from "../../url";
import {Navigate} from "react-router-dom";
import IncludeRow from './IncludeRow';
import NotToIncludeRow from './NotToIncludeRow';
import ThingsToCarryRow from './ThingsToCarryRow';
import validate from '../validate';
import Modal from 'react-modal';

function CreatePost() {
  const [bookDetails, setBookDetails] = useState([
    {
      index: Math.random(),
      includeRow: ""
    }
  ]);

  const [notIncludedDetails, setNotIncludedDetails] = useState([
    {
      index: Math.random(),
      notIncludeRow: ""
    }
  ]);

  const [thingsToCarryDetails, setThingsToCarryDetails] = useState([
    {
      index: Math.random(),
      thingsToCarryRow: ""
    }
  ]);

  const addNewRow = () => {
    setBookDetails(prevState => [
      ...prevState,
      {
        index: Math.random(),
        includeRow: "",
      }
    ]);
  };

  const addNotIncludedRow = () => {
    setNotIncludedDetails(prevState => [
      ...prevState,
      {
        index: Math.random(),
        notIncludeRow: "",
      }
    ]);
  };

  const addThingsRow = () => {
    setThingsToCarryDetails(prevState => [
      ...prevState,
      {
        index: Math.random(),
        thingsToCarryRow: "",
      }
    ]);
  };

  const clickOnDelete = record => {
    const updatedList = bookDetails.filter(r => r !== record);
    setBookDetails(updatedList);
  };
  const clickOnNotIncludeDelete = record => {
    const updatedNotIncludeList = notIncludedDetails.filter(r => r !== record);
    setNotIncludedDetails(updatedNotIncludeList);
  };
  const clickOnDeleteThings = record => {
    const updatedThingsList = thingsToCarryDetails.filter(r => r !== record);
    setThingsToCarryDetails(updatedThingsList);
  };
  const [trekName,setTrekName] = useState('');
  const [totalSpots,setTotalSpots] = useState('');
  const [numberOfDays,setNumberOfDays] = useState('');
  const [startDate,setStartDate] = useState('');
  const [endDate,setEndDate] = useState('');
  const [trekLocation,setTrekLocation] = useState('');
  const [trekGmapLocation,setTrekGmapLocation] = useState('');
  const [trekPrice, setTrekPrice] = useState('');
  const [expDate, setExpDate] = useState('');
  const [pickUpLocation,setPickUpLocation] = useState('');
  const [pickUpGmapLocation,setPickUpGmapLocation] = useState('');
  const [trekDescription,setTrekDescription] = useState('');
  const [difficultyLevel,setDifficultyLevel] = useState('');
  const [trekLength,setTrekLength] = useState('');
  const [altitude,setAltitude] = useState('');
  const [minAge,setMinAge] = useState('');
  const [base64ImageData, setBase64ImageData] = useState(null); 
  const [redirect, setRedirect] = useState(false);
  const [fileExtension, setFileExtension] = useState('');

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");

  function getFileExtension(filename){
    return filename.split('.').pop().toLowerCase(); 
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    const extension = getFileExtension(file.name);
    setFileExtension(extension);

    const reader = new FileReader();
  
    reader.onloadend = () => {
      const base64String = reader.result;
      setBase64ImageData(base64String); 
    };
  
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  async function createNewPost(ev) {
    ev.preventDefault();
    const data = new FormData();
    data.set('trekName', trekName);
    data.set('totalSpots', totalSpots);
    data.set('numberOfDays', numberOfDays);
    data.set('startDate', startDate);
    data.set('endDate', endDate);
    data.set('trekLocation', trekLocation);
    data.set('trekGmapLocation', trekGmapLocation);
    data.set('trekPrice', trekPrice);
    data.set('expDate', expDate);
    data.set('pickUpLocation', pickUpLocation);
    data.set('pickUpGmapLocation', pickUpGmapLocation);
    data.set('trekDescription', trekDescription);
    data.set('difficultyLevel', difficultyLevel);
    data.set('trekLength', trekLength);
    data.set('altitude', altitude);
    data.set('minAge', minAge);
    data.set('bookDetails', JSON.stringify(bookDetails));
    data.set('notIncludedDetails', JSON.stringify(notIncludedDetails));
    data.set('thingsToCarryDetails',  JSON.stringify(thingsToCarryDetails));
    if (base64ImageData) data.set('thumbnailImage', base64ImageData);

    const handleModal = (message) => {
      openModal(message);
    };

    if (!validate.validateTrekDetails(trekName, totalSpots, numberOfDays, startDate, endDate, trekLocation, trekGmapLocation, trekPrice, expDate, pickUpLocation, pickUpGmapLocation, trekDescription, difficultyLevel, trekLength, altitude, minAge, bookDetails, notIncludedDetails, thingsToCarryDetails, base64ImageData, fileExtension, handleModal)) {
      return;
    }

    const response = await fetch(`${BASE_URL}/post`, {
      method: 'POST',
      body: data,
      credentials: 'include',
    });
    if (response.ok) {
      setRedirect(true);
    }
  }

  const openModal = (message) => {
    setModalContent(message);
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  if(redirect){
    alert("New Trek Added Successfully!")
    window.location.href = "admin/dashboard";
  }
    return (
    <div className="content aboutTop">
      <form onSubmit={createNewPost} className="aboutTop">
      <div className="postForm">
        <h2 style={{color: "#eee"}} className="trekName">ADD NEW TREK</h2>
        <hr/>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>TREK NAME</label>
            <input type="trekName" value={trekName} onChange={ev => setTrekName(ev.target.value)} className="input5"/>
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>TREK DESCRIPTION</label>
            <input type="trekDescription" value={trekDescription} onChange={ev => setTrekDescription(ev.target.value)} className="input2"/>
          </div>
        </div>
        <div className="side-by-side">
          <input type="file" onChange={handleFileInputChange} className="input2" />
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>MAXIMUM TREKKRS</label>
            <input type="number" value={totalSpots} onChange={ev => setTotalSpots(ev.target.value)} className="input2" />
          </div>
          <div className="textOnInput">
            <label>NUMBER OF DAYS</label>
            <input type="number" value={numberOfDays} onChange={ev => setNumberOfDays(ev.target.value)} className="input2" />
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>START DATE</label>
            <input type="date" value={startDate} onChange={ev => setStartDate(ev.target.value)} className="input2 date" placeholder={"START DATE"} />
          </div>
          <div className="textOnInput">
            <label>END DATE</label>
            <input type="date" value={endDate} onChange={ev => setEndDate(ev.target.value)} className="input2 date" placeholder={"END DATE"} />
          </div>
        </div>

        <div className="side-by-side">
          <div className="textOnInput">
            <label >TREK LOCATION</label>
            <input type="trekLocation" value={trekLocation} onChange={ev => setTrekLocation(ev.target.value)} className="input2"  />
          </div>
          <div className="textOnInput">
            <label >TREK LOCATION GOOGLE MAP LINK</label>
            <input type="trekGmapLocation" value={trekGmapLocation} onChange={ev => setTrekGmapLocation(ev.target.value)} className="input2"/>
          </div>
        </div>

        <div className="side-by-side">
          <div className="textOnInput">
            <label >PRICE</label>
            <input type="number" value={trekPrice} onChange={ev => setTrekPrice(ev.target.value)} className="input2"/>
          </div>
          <div className="textOnInput">
            <label >LAST DATE TO SUBMIT FORM</label>
            <input type="date" value={expDate} onChange={ev => setExpDate(ev.target.value)} className="input2 date" />
          </div>
        </div>

        <div className="side-by-side">
          <div className="textOnInput">
            <label >PICK UP LOCATION</label>
            <input type="pickUpLocation" value={pickUpLocation} onChange={ev => setPickUpLocation(ev.target.value)} className="input2" />
          </div>
          <div className="textOnInput">
            <label >PICK UP LOCATION GOOGLE MAP LINK</label>
            <input type="pickUpGmapLocation" value={pickUpGmapLocation} onChange={ev => setPickUpGmapLocation(ev.target.value)} className="input2" />
          </div>
        </div>

        <div className="side-by-side">
          <div className="textOnInput">
            <label >DIFFICULTY LEVEL</label>
            <input type="difficultyLevel" value={difficultyLevel} onChange={ev => setDifficultyLevel(ev.target.value)} className="input2" placeholder={""} />
          </div>
          <div className="textOnInput">
            <label >TREK LENGTH</label>
            <input type="trekLength" value={trekLength} onChange={ev => setTrekLength(ev.target.value)} className="input2" />
          </div>
        </div>

        <div className="side-by-side">
          <div className="textOnInput">
            <label >ALTITUDE</label>
            <input type="altitude" value={altitude} onChange={ev => setAltitude(ev.target.value)} className="input2" />
          </div>
          <div className="textOnInput">
            <label >MINIMUM AGE</label>
            <input type="minAge" value={minAge} onChange={ev => setMinAge(ev.target.value)} className="input2" />
          </div>
        </div>
        <br/>
        <h2 style={{color: "#eee"}} className="trekSubHeading">What's Included</h2>
        <hr/>
        <IncludeRow
          add={addNewRow}
          delete={clickOnDelete}
          bookDetails={bookDetails}
          setBookDetails={setBookDetails}
        />
        <br/>
        <h2 style={{color: "#eee"}} className="trekSubHeading">What's Not Included</h2>
        <hr/>
        <NotToIncludeRow
          add={addNotIncludedRow}
          delete={clickOnNotIncludeDelete}
          notIncludedDetails={notIncludedDetails}
          setNotIncludedDetails={setNotIncludedDetails}
        />
        <br/>
        <h2 style={{color: "#eee"}} className="trekSubHeading">Things to carry</h2>
        <hr/>
        <ThingsToCarryRow
          add={addThingsRow}
          delete={clickOnDeleteThings}
          thingsToCarryDetails={thingsToCarryDetails}
          setThingsToCarryDetails={setThingsToCarryDetails}
        />
        <button className="createPost" style={{marginTop:'5px'}}>Create New Trek</button>
        </div>
      </form>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Alert Modal"
          style={{
            content: {
              width: '90%', 
              maxWidth: '450px', 
              height: '200px',
              maxHeight: '325px', 
              margin: 'auto',
              borderRadius: '8px',
              padding: '25px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              overflow: 'auto',
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1000,
            }
          }}
        >
      <div style={{ marginBottom: '15px' }}>
        <h2 style={{ margin: '0', paddingBottom: '5px', borderBottom: '1px solid #ccc' }} className="trekName">Alert</h2>
      </div>
      <div style={{ marginBottom: '15px' }}>
        <p style={{ margin: '0' }} className="alertText">{modalContent}</p>
      </div>
      <div style={{ float: 'right' }}>
        <button onClick={closeModal}>CLOSE</button>
      </div>
    </Modal>
  </div>
  )
}

export default CreatePost